import styled from 'styled-components';

export const StyledSessionResultPopup = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap ? $gap : '0.75rem'};
  background: ${({ theme }) => theme.background};
`;

export const SessionResultContainer = styled.div`
  width: 100%;
  border-top: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);
`;

export const SessionResultControls = styled.div`
  width: 100%;
  padding: 1.625rem;
`;

export const SessionResultDecorator = styled.div`
  height: ${({ theme }) => theme.frameWidth};
  width: 12rem;
  margin-top: -${({ theme }) => theme.frameWidth};
  background: ${({ theme }) => theme.selection};
  border-right: solid 2px ${({ theme }) => theme.borderDark};
  border-left: solid 2px ${({ theme }) => theme.borderDark};
`;

export const SessionResultImage = styled.img`
  width: 28rem;
  height: 12rem;
  object-fit: cover;
`;
